import { createSlice } from '@reduxjs/toolkit';

import { isAuthEnabled } from '#/config/auth';
import { getAccess } from '#/utils/auth/tokenStorage';

const initialState = {
  access: getAccess(),
  user: null,
  roles: [],
  permissions: [],
  /** Auth 關閉時視為已就緒；有 token 時須等 GET /auth/me */
  permissionsReady: !isAuthEnabled,
  isMeLoading: false,
  meError: null,
  isSubmitting: false,
  error: null,
};

function clearSessionFields(state) {
  state.access = null;
  state.user = null;
  state.roles = [];
  state.permissions = [];
  state.permissionsReady = !isAuthEnabled;
  state.isMeLoading = false;
  state.meError = null;
}

const infraSlice = createSlice({
  name: 'infra',
  initialState,
  reducers: {
    userLogin: (state) => {
      state.isSubmitting = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.access = action.payload?.access ?? null;
      state.user = action.payload?.user ?? null;
      state.roles = [];
      state.permissions = [];
      state.permissionsReady = false;
      state.meError = null;
      state.isSubmitting = false;
      state.error = null;
    },
    loginFailure: (state, action) => {
      clearSessionFields(state);
      state.isSubmitting = false;
      state.error = action.payload;
    },
    userLogout: (state) => {
      state.isSubmitting = true;
      state.error = null;
    },
    logout: (state) => {
      clearSessionFields(state);
      state.isSubmitting = false;
      state.error = null;
    },
    fetchMe: (state) => {
      state.isMeLoading = true;
      state.meError = null;
    },
    meSuccess: (state, action) => {
      const payload = action.payload ?? {};
      state.user = payload.user ?? state.user;
      state.roles = Array.isArray(payload.roles) ? payload.roles : [];
      state.permissions = Array.isArray(payload.permissions) ? payload.permissions : [];
      state.permissionsReady = true;
      state.isMeLoading = false;
      state.meError = null;
    },
    meFailure: (state, action) => {
      state.isMeLoading = false;
      state.permissionsReady = false;
      state.meError = action.payload ?? { message: '載入使用者權限失敗' };
    },
  },
});

export const {
  userLogin,
  loginSuccess,
  loginFailure,
  userLogout,
  logout,
  fetchMe,
  meSuccess,
  meFailure,
} = infraSlice.actions;
export default infraSlice.reducer;
